var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineHierarchySquare3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.05 13.8V9.6c0-.41.34-.75.75-.75s.75.34.75.75v4.2c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16.05c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7zm1.5 0c0 .66.54 1.2 1.2 1.2.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2-.66 0-1.2.54-1.2 1.2zM5.25 7.8c0-1.41 1.14-2.55 2.55-2.55s2.55 1.14 2.55 2.55-1.14 2.55-2.55 2.55S5.25 9.21 5.25 7.8zm1.5 0a1.05 1.05 0 1 0 2.1 0 1.05 1.05 0 0 0-2.1 0zM13.65 7.8c0-1.41 1.14-2.55 2.55-2.55s2.55 1.14 2.55 2.55-1.14 2.55-2.55 2.55-2.55-1.14-2.55-2.55zm1.5 0a1.05 1.05 0 1 0 2.1 0 1.05 1.05 0 0 0-2.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69 14.53a.75.75 0 0 1-.54-.91 3.168 3.168 0 0 1 3.08-2.38h.01l2.06.01h.01c1.21 0 2.28-.76 2.68-1.9a.748.748 0 1 1 1.41.5 4.32 4.32 0 0 1-4.11 2.91l-2.06-.01h-.01c-.77 0-1.44.52-1.63 1.26-.07.32-.38.54-.71.54-.06 0-.13-.01-.19-.02z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineHierarchySquare3);
export default __webpack_public_path__ + "static/media/vuesax-outline-hierarchy-square-3.e9638f327a9c610de3d421e2f3f0783d.svg";
export { ForwardRef as ReactComponent };